import { useEffect, useState } from 'react'

export default function Intro() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const frame = requestAnimationFrame(() => setReady(true))
    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <div>
      <div className="mnd-section-container" id="introContainer">
        <div className={`logo-content center${ready ? ' logo-ready' : ''}`}>
          <img src="images/logo0.png" className="monkey-logo img-centered" />
        </div>
        <div className="banner">
          <h2>MandrilSoft</h2>
        </div>
      </div>
    </div>
  )
}
